import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6c343084&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoOnlyHeader: require('E:/Jenkins/workspace/PowerBi-Dashboard Magnet agmemod dashboard (WEcR)/Presentatie/src/components/LogoOnlyHeader.vue').default,DefaultTemplate: require('E:/Jenkins/workspace/PowerBi-Dashboard Magnet agmemod dashboard (WEcR)/Presentatie/src/components/DefaultTemplate.vue').default,MobileLayout: require('E:/Jenkins/workspace/PowerBi-Dashboard Magnet agmemod dashboard (WEcR)/Presentatie/src/components/mobile/MobileLayout.vue').default})
